import { Radio, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useTypedSelector } from '../../../../store';
import { justTypeUpdated, JUST_DEM_PAY, JUST_JUDGEMENT, JUST_LS_MAIN } from '../../../../store/justOpts';
import { RowExt } from '../../../../styles';
import { RadioButtonResp } from './JustIntCap';


const JustType = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const justType
   = useTypedSelector(state =>
     state.justOpts.justType);

  return (
    <>
      <RowExt marginTop="md">
        <Typography.Title level={4}>
          {t('justType.type')}
        </Typography.Title>
      </RowExt>
      <RowExt marginTop="sm">
        <Radio.Group
          value={justType}
          size="middle"
          onChange={
           (event) => {
             dispatch(justTypeUpdated(event.target.value));
           }
         }
        >
          <RadioButtonResp value={JUST_LS_MAIN}>{t('justType.lawsuit')}</RadioButtonResp>
          <RadioButtonResp value={JUST_JUDGEMENT}>{t('justType.court')}</RadioButtonResp>
          <RadioButtonResp value={JUST_DEM_PAY}>{t('justType.wez')}</RadioButtonResp>
        </Radio.Group>
      </RowExt>
    </>
  );
};

export default JustType;
